(() => {
  function init() {
    const story = document.querySelector('[data-tep-story]');
    const purchase = document.querySelector('.tep-purchase');
    if (!story || !purchase || story.dataset.ready) return;
    story.dataset.ready = 'true';
    const buy = purchase.querySelector('.product-detail__buy-buttons') || purchase;
    const bar = story.querySelector('[data-tep-sticky]');
    document.querySelectorAll('[data-tep-jump], [data-tep-purchase]').forEach(link => {
      link.addEventListener('click', event => {
        const target = link.hasAttribute('data-tep-purchase') ? buy : document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({behavior:'instant', block:link.hasAttribute('data-tep-purchase') ? 'center' : 'start'});
        const focus = target.querySelector('button[type="submit"]:not([disabled])') || target.querySelector('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])') || target;
        if (!focus.matches('a[href], button, input, select, textarea') && !focus.hasAttribute('tabindex')) focus.setAttribute('tabindex','-1');
        focus.focus({preventScroll:true});
      });
    });
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(buy);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
